import { gql } from '@apollo/client';

export const GET_FIND_SYNC_QUERY = gql`
  query GetFindSync($siteId: ID, $findId: ID, $preview: Boolean) {
    getFindSync(siteId: $siteId, findId: $findId, preview: $preview) {
      config {
        id
        tabs
      }
      sheetUrl
      tabs
      stats {
        acolyte
        sheet
        amcr
        unavailableAmcr
        createAcolyte
        updateAcolyte
        createSheet
        updateSheet
        conflicts
        upToDate
      }
      rows {
        key
        findId
        updatedAt
        sheetTab
        sheetRow
        sheetFingerprint
        sheetLinkDiff
        reasons
        conflict
        image
        images
        amcrImages
        fields {
          evId {
            acolyte
            sheet
          }
          amcrId {
            acolyte
            sheet
          }
          type {
            acolyte
            sheet
            amcr
          }
          material {
            acolyte
            sheet
            amcr
          }
          era {
            acolyte
            sheet
            amcr
          }
          description {
            acolyte
            sheet
            amcr
          }
          note {
            acolyte
            sheet
            amcr
          }
          foundAt {
            acolyte
            sheet
            amcr
          }
        }
        final {
          evId
          amcrId
          type
          material
          era
          description
          note
          foundAt
        }
      }
    }
  }
`;
